Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.FontType = module.exports.default = {
	DEVICE: "device",
	EMBEDDED: "embedded",
	EMBEDDED_CFF: "embeddedCFF"
};